<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="UserId"
      ref="list"
      unit="采购需求单"
      :page="page"
      :show-query="true"
      :show-checkbox="true"
      :get-data-func="api.list"
      :temp-params="tempParams"
      @row-select="rowSelect"
      @onSelCheck="onSelCheck"
      @onAllCheck="onAllSelCheck"
      urlHash="production/clothmanagement/newdemand"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="明细" name="first">
        <div style="display: flex; margin-bottom: 10px">
          <el-button type="primary" @click="onCustomTable1" icon="el-icon-s-tools">明细项</el-button>
          <!-- <el-button type="primary" @click="onCustomTable">生产采购订单</el-button> -->
        </div>
        <el-table ref="multipleTable" :row-key="row => row.Prop" :data="tableData" v-if="show" max-height="600" stripe border>
          <el-table-column type="selection" width="55"></el-table-column>
          <template v-for="(item, index) in tableColumns1">
            <!-- 需判断是否有价格的权限  -->
            <template v-if="item.IsShow">
              <el-table-column
                :resizable="false"
                :key="`${item.Prop}-${index}`"
                :prop="item.Prop"
                v-if="shouldShowColumn(item)"
                :label="item.Label"
                :align="item.Align ?? 'left'"
                :min-width="item.Width"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  <span v-if="isNumericProperty(item.Prop)">{{ $commonJs.toThousands(row[item.Prop]) }}</span>
                  <span v-else>{{ row[item.Prop] }}</span>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="汇总" name="second">
        <div style="display: flex; margin-bottom: 10px">
          <el-button type="primary" @click="onCustomTable2" icon="el-icon-s-tools">明细项</el-button>
          <!-- <el-button type="primary" @click="onCustomTable">生产采购订单</el-button> -->
        </div>
        <el-table ref="multipleTable" :row-key="row => row.Prop" :data="tableData2" v-if="show" max-height="600" stripe border>
          <el-table-column type="selection" width="55"></el-table-column>
          <template v-for="(item, index) in tableColumns2">
            <!-- 需判断是否有价格的权限  -->
            <template v-if="item.IsShow">
              <el-table-column
                :resizable="false"
                :key="`${item.Prop}-${index}`"
                :prop="item.Prop"
                v-if="shouldShowColumn(item)"
                :label="item.Label"
                :align="item.Align ?? 'left'"
                :min-width="item.Width"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  <span v-if="isNumericProperty(item.Prop)">{{ $commonJs.toThousands(row[item.Prop]) }}</span>
                  <span v-else>{{ row[item.Prop] }} </span>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <customTableDialog1 ref="customTableDialog1" @onSave="onSave1" :initTableData="tableColumns1" tableType="采购需求单明细" />
    <customTableDialog2 ref="customTableDialog2" @onSave="onSave2" :initTableData="tableColumns2" tableType="采购需求单汇总" />
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import customTableDialog1 from '@/components/common/customTableDialog/customTableDialog'
import customTableDialog2 from '@/components/common/customTableDialog/customTableDialog'

export default {
  mixins: [listMixin],
  components: { list, customTableDialog1, customTableDialog2 },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  props: {
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {
      api: require('@/api/production/clothProduction').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      FieldSettingApi: require('@/api/sy/fieldSetting').default,
      puPurchaseDemandApi: require('@/api/pu/puPurchaseDemand').default,
      trendShow: true,
      tableData: [],
      tableData2: [],
      tempParams: {
        ProductionStatus: 1,
        IsCloth: true
      },
      tableColumns1: [],
      tableColumns2: [],
      show: false,
      activeName: 'first',
      orderProductNos: []
    }
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/outsourcingpicking')
    }
  },
  created() {
    this.getTableColumns1()
    this.getTableColumns2()
  },
  methods: {
    handleClick(tab) {
      if (tab.label == '汇总') {
        if (this.orderProductNos.length == 0) return (this.tableData2 = [])
        this.show = true
        const o = {
          OrderType: 25,
          ProcessStage: 0,
          ShowAll: false,
          OrderProductNos: this.orderProductNos
        }
        this.puPurchaseDemandApi.workDocSummary(o).then(res => {
          this.tableData2 = res.Data
        })
      }
    },
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false
      const priceProps = ['PurchasePrice', 'SalePrice', 'RetailPrice', 'QuotedPrice', 'Discount', 'TaxRate', 'Price', 'TaxPrice', 'Amount', 'TaxLimit', 'TaxAmount', 'DiscountAmount', 'Rate', 'Price']
      return (this.canPrice && priceProps.includes(item.Prop)) || !priceProps.includes(item.Prop)
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ['PuQuantity', 'Amount', 'TaxAmount'].includes(prop)
    },
    async getTableColumns1() {
      const res = await this.FieldSettingApi.list({ Type: '采购需求单明细' })
      this.tableColumns1 = []
      this.tableColumns1 = res.Data
    },
    onCustomTable1() {
      this.$refs.customTableDialog1.dialogVisible = true
    },
    onSave1() {
      this.getTableColumns1()
      this.$message.success('保存成功')
    },
    async getTableColumns2() {
      const res = await this.FieldSettingApi.list({ Type: '采购需求单汇总' })
      this.tableColumns2 = []
      this.tableColumns2 = res.Data
    },
    onCustomTable2() {
      this.$refs.customTableDialog2.dialogVisible = true
    },
    onSave2() {
      this.getTableColumns2()
      this.$message.success('保存成功')
    },
    getMachiningStageList() {
      this.machiningStageApi.list({ Status: 1 }).then(res => {
        res.Data.forEach(item => {
          this.machiningStageList.unshift({ value: item.Name, label: item.Name })
        })
      })
    },
    rowSelect(row) {
      // this.activeName = 'first'
      // this.show = true
      // let id = row.DocId;
      // this.puPurchaseDemandApi.workDocList(id).then(res => {
      //   this.tableData = res.Data.Products;
      // })
    },
    onSelCheck(selection) {
      if (selection.length == 0) {
        this.tableData = []
        this.tableData2 = []
        this.orderProductNos = []
        return
      }
      this.activeName = 'first'
      this.show = true
      const OrderProductNos = selection.map(item => item.OrderProductNo)
      this.orderProductNos = OrderProductNos
      const o = {
        OrderType: 25,
        ProcessStage: 0,
        ShowAll: false,
        OrderProductNos: OrderProductNos
      }
      this.puPurchaseDemandApi.workDocList(o).then(res => {
        this.tableData = res.Data
      })
    },
    onAllSelCheck(selection) {
      if (selection.length == 0) {
        this.tableData = []
        this.tableData2 = []
        this.orderProductNos = []
        return
      }
      this.activeName = 'first'
      this.show = true
      const OrderProductNos = selection.map(item => item.OrderProductNo)
      this.orderProductNos = OrderProductNos
      const o = {
        OrderType: 25,
        ProcessStage: 0,
        ShowAll: false,
        OrderProductNos: OrderProductNos
      }
      this.puPurchaseDemandApi.workDocList(o).then(res => {
        this.tableData = res.Data
      })
    }
  }
}
</script>
